import { InputLabel } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import React from "react";
import { FormTermsLabel } from "../components/signup/forms/FormTermsLabel";
import { FormTitle } from "../components/signup/forms/FormTitle";
import { COUNTRIES, NOT_IN_COUNTRIES } from "../const/countries.const";
import { InfoIconToolTip } from "../yoello-lib/modules/components/UI/InfoIconToolTip/InfoIconToolTip";
import FormAutoComplete from "../yoello-lib/modules/dynamicForms/FormComponents/FormAutoComplete";
import FormCheckBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormCheckBox";
import FormPhoneNumberBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormPhoneNumberBox";
import FormSelect from "../yoello-lib/modules/dynamicForms/FormComponents/FormSelect";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import TermsOfService from '../container/SelfSignup/TermsOfService';
import hostClient from "../yoello-lib/modules/host/HostClient";
import { Acquirers, FeePlans, OnboardingSources } from "../components/signup/types";
import { Host, hosts } from "../yoello-lib/modules/host/Hosts";
import { getCurrencySymbolForLeadSource } from "../utils/getCurrencySymbolForLeadSource";
import { IntegrationsList } from "../components/orders/constants";
import { FormPasswordInput } from "../yoello-lib/modules/dynamicForms/FormComponents/FormPasswordInput";


export const IntegrationsMetaDataKeys = {
    DELIVERECT:[{key:"integration_object_id",value:"integration_object_id"}],
    NCR:[{key:"integration_object_id",value:"integration_object_id"}],
    ORACLE:[
        {key:"client_id",value:"client_id"},
        {key:"username",value:"username"},
        {key:"password",value:"password"},
        {key:"orgname",value:"orgname"},
        {key:"employee_ref_id",value:"employee_ref_id"}
    ],
    ZONAL:[
        {key:"integration_object_id",value:"integration_object_id"},
    ],
    TEVALIS:[
        {key:"guid",value:"guid"},
        {key:"guid2",value:"guid2"},
        {key:"company_id",value:"company_id"},
        {key:"site_id",value:"site_id"},
    ]
}

const countryArray = [...COUNTRIES.map((country) => ({
    name: country.name,
    value: country.code,
})),
{
    name: "divider", value: 'invalid',
    disabled: true,
    element: <div style={{ borderBottom: "1px #E8EAF4 solid", width: '100%' }} />
},
...NOT_IN_COUNTRIES.map((country) => ({
    name: country.name,
    value: country.code,
}))];

const EmailError = ({ t, host }: any) => <>{t("signup.form.emailError")}
    <InfoIcon style={{position:"absolute",marginTop:"2px"}}  title={helperText[host] ? helperText[host].email : "signup.form.emailErrorInfo"} />
</>

const InfoIcon = ({ title, style }: any) => <span style={{ marginLeft: "5px", ...style }}>
    <InfoIconToolTip
        infoMessage={title} />
</span>;

type CallEmailLookup = (email: string) => Promise<boolean>;

export function userDetailsForm(callEmailLookup: CallEmailLookup, t: any,host?:string): IDynamicFormRow[] {
    /**Add email verification code here */
    async function validateAccount(value: string) {
        const isExist = await callEmailLookup(value);
        return isExist === true ?
            <EmailError t={t} />
            : true;
    }
    let detailsFormRows:IDynamicFormRow[] = [
        {
            label: "forms.register.firstname",
            keyName: "first_name",
            gridColumnOptions: { formCol: 12 },
            Component: FormTextBox,
            registerOptions: {
                required: true,
            },
        },
        {
            label: "forms.register.lastname",
            keyName: "last_name",
            gridColumnOptions: { formCol: 12 },
            Component: FormTextBox,
            registerOptions: {
                required: true,
            },
        },
        {
            label: "signup.form.contactNo",
            keyName: "contact_phone",
            gridColumnOptions: { formCol: 12 },
            Component: FormPhoneNumberBox,
            registerOptions: {
                required: true,
                minLength: 5
            },
            formProps: {
                triggerValidationOnChange: true
            }
        },
        {
            label: "forms.register.email",
            keyName: "contact_email",
            gridColumnOptions: { formCol: 12 },
            Component: FormTextBox,
            inputProperties: {
                type: 'email',
                autoComplete: 'email'
            },
            registerOptions: {
                required: true,
                validate: {
                    validateEmail,
                    //@ts-ignore
                    validateAccount
                }
            },
        }, {
            label: "signup.form.termsLabel",
            keyName: "terms",
            gridColumnOptions: { formCol: 12 },
            Component: FormCheckBox,
            formProps: {
                overrideJSXLabel: <FormTermsLabel />
            },
            registerOptions: {
                validate: (value: boolean) => {
                    return value === true ? value : t('signup.form.termsValidation')
                }
            }
        }]        
    
    return detailsFormRows;
}
function isValidEmail(value: string) {
    // eslint-disable-next-line
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(value);
}
/**Checks for valid email address */
function validateEmail(value: string, allowedEmpty?: boolean) {
    if (allowedEmpty && value.length === 0) return;

    return isValidEmail(value) || "Invalid email";
}

const VENUE_COUNT = [
    { name: "1", value: "1" },
    { name: "1-5", value: "1-5" },
    { name: "5-10", value: "5-10" },
    { name: "10-20", value: "10-20" },
    { name: "20+", value: "20+" },
]

export const getIntegrationExtraInputs = (host:string, fullWidthInput?:boolean):IDynamicFormRow[]=>{
    switch (host) {
        case OnboardingSources.deliverect:
            return [{
                label: "forms.register.deliverectChannelLinkId",
                keyName: "integration_object_id",
                gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                Component: FormTextBox,
                registerOptions: {
                    required: true,
                }}]
        
            case OnboardingSources.zonal:
                    return [
                        {
                            label: "forms.register.site_id",
                            keyName: "integration_object_id",
                            gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                            Component: FormTextBox,
                            registerOptions: {
                                required: true,
                }},
                ]
                case OnboardingSources.ncr:
                        return [
                            {
                                label: "forms.register.enterprise_unit",
                                keyName: "integration_object_id",
                                gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                                Component: FormTextBox,
                                registerOptions: {
                                    required: true,
                            }},]
            
        case OnboardingSources.oracle:
            return [{
                label: "forms.register.clientId",
                keyName: "client_id",
                gridColumnOptions: { formCol: 6 },
                Component: FormTextBox,
                registerOptions: {
                    required: true,
                }},
                {
                    label: "forms.register.username",
                    keyName: "username",
                    gridColumnOptions: { formCol: 6 },
                    Component: FormTextBox,
                    registerOptions: {
                        required: true,
                }},
                {
                    label: "forms.register.password",
                    keyName: "password",
                    gridColumnOptions: { formCol: 6 },
                    Component: FormPasswordInput,
                    registerOptions: {
                        required: true,
                }},
                {
                    label: "forms.register.orgname",
                    keyName: "orgname",
                    gridColumnOptions: { formCol: 6 },
                    Component: FormTextBox,
                    registerOptions: {
                        required: true,
                }},
                {
                    label: "forms.register.employeeNumber",
                    keyName: "employee_ref_id",
                    gridColumnOptions: { formCol: 6 },
                    Component: FormTextBox,
                    registerOptions: {
                        required: true,
                }},
            ]

        case OnboardingSources.tevalis:
            return [
                {
                        label: "forms.register.guid",
                        keyName: "guid",
                        gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                        Component: FormTextBox,
                        registerOptions: {
                            required: true,
                }},
                {
                        label: "forms.register.guid2",
                        keyName: "guid2",
                        gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                        Component: FormTextBox,
                        registerOptions: {
                            required: true,
                }},
                {
                        label: "forms.register.company_id",
                        keyName: "company_id",
                        gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                        Component: FormTextBox,
                        registerOptions: {
                            required: true,
                }},
                {
                        label: "forms.register.site_id",
                        keyName: "site_id",
                        gridColumnOptions: { formCol: fullWidthInput ? 12 : 6 },
                        Component: FormTextBox,
                        registerOptions: {
                            required: true,
                }},
            
            ]


        default:
            return []
    }
}

export function venueDetailsForm(t: any,host:string): IDynamicFormRow[] {
    let venueDetailsFormArray:IDynamicFormRow[] = [
        {
            label: "forms.details.venueName",
            keyName: "venue_name",
            gridColumnOptions: { formCol: 12 },
            Component: FormTextBox,
            registerOptions: {
                required: true,
            },
            inputProperties: {
                helperText: t('signup.form.venueNameHelper')
            }
        },
        {
            label: "signup.form.venueLocation",
            keyName: "venue_location",
            formProps: {
                selectOptions: countryArray,
                renderOption: (option: any) => {
                    if (React.isValidElement(option.element)) {
                        return option.element;
                    }
                    return option.name;
                },
                triggerValidationOnChange: true

            },
            inputProperties: {
                required: true,
                helperText: ""
            },
            Component: FormAutoComplete,
            gridColumnOptions: { formCol: 12 },
            registerOptions: {
                required: true,
            },
        },
        {
            label: "signup.form.totalVenues",
            keyName: "number_of_venues",
            formProps: {
                selectOptions: VENUE_COUNT
            },
            inputProperties: { placeholder: 'No items selected' },
            Component: FormSelect,
            gridColumnOptions: { formCol: 12 },
            registerOptions: {
                required: true,
            },
        },
    ]
    if(host.toUpperCase() !== "PARTNERS"){
        venueDetailsFormArray.push(...getIntegrationExtraInputs(host.toUpperCase()))
    }

    return venueDetailsFormArray
}



const titles: Record<string, Record<string, string>> = {
    barclaycard: {
        payment: "signup.form.barclaycardDetails",
        merchant: "signup.form.yourDetails"
    },
    rms: {
        payment: "signup.form.paymentSpecialistTitle",
        merchant: "signup.form.merchantDetails"
    },
    cardsaver: {
        payment: "signup.form.paymentSpecialistTitle",
        merchant: "signup.form.merchantDetails"
    },
    worldpay: {
        payment: "signup.form.paymentSpecialistTitle",
        merchant: "signup.form.merchantDetails"
    },
    zerobubble: {
        payment: "signup.form.paymentSpecialistTitle",
        merchant: "signup.form.merchantDetails"
    },
    bna: {
        payment: "signup.form.paymentSpecialistTitle",
        merchant: "signup.form.merchantDetails"
    },
    deliverect: {
        payment: "signup.form.yoelloEmployeeTitle",
        merchant: "signup.form.merchantDetails"
    },
    ncr: {
        payment: "signup.form.yoelloEmployeeTitle",
        merchant: "signup.form.merchantDetails"
    },
    oracle: {
        payment: "signup.form.yoelloEmployeeTitle",
        merchant: "signup.form.merchantDetails"
    },
    tevalis: {
        payment: "signup.form.yoelloEmployeeTitle",
        merchant: "signup.form.merchantDetails"
    },
    zonal: {
        payment: "signup.form.yoelloEmployeeTitle",
        merchant: "signup.form.merchantDetails"
    }
}

const helperText: Record<string, Record<string, string>> = {
    barclaycard: {
        venue: "signup.form.signUpVenueInfo",
    },
    rms: {
        venue: "signup.form.rmsVenueHelper",
        email: "signup.form.rmsEmailHelper"
    },
    cardsaver: {
        venue: "signup.form.rmsVenueHelper",
        email: "signup.form.rmsEmailHelper"
    },
    worldpay: {
        venue: "signup.form.signUpVenueInfo",
    },
    zerobubble: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    },
    bna: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    },
    deliverect: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    },
    ncr: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    },
    oracle: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    },
    tevalis: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    },
    zonal: {
        venue: "signup.form.zeroBubbleSignUpVenueInfo",
        email: "signup.form.rmsEmailHelper",
    }
}
export function leadForm(
    t: any,
    callEmailLookup: CallEmailLookup,
    className: ClassNameMap<string>,
    leadSource: Host,
    feePlans: FeePlans[] | undefined): IDynamicFormRow[] {
    const host = hostClient.host;
    const hTitles = titles[host];

    const isZeroBubbleLead = leadSource === hosts.zerobubble;
    const isBNALead = leadSource === hosts.bna;
    const isZonalLead = leadSource === hosts.zonal;
    const processingFeeHosts:Host[] = [hosts.bna, hosts.zerobubble, hosts.zonal];
    const hasProcessingFee = processingFeeHosts.includes(leadSource);

    const generatePhoneCountryCode = () => {
        if (isZeroBubbleLead) {
            return "mt";
        }
        if (isBNALead) {
            return "ca";
        }
        return "gb";
    };

    async function validateAccount(value: any) {
        const isExist = await callEmailLookup(value);
        return isExist === true ?
            <EmailError t={t} host={host} />
            : true;
    }

    function getCountries() {
        const countries = [...COUNTRIES];
        if (isZeroBubbleLead) {
            countries.push({ key: "malta", name: "Malta", code: "MT" })
        }
        return countries.map((country) => ({
            name: country.name,
            value: country.code,
        }));
    }

    function getSelectOptions(leadSource: string) {
        let TRANSACTION_FEE_PLANS = VENUE_COUNT;
        const currencySymbol = getCurrencySymbolForLeadSource(leadSource)
        if (feePlans && feePlans.length > 0) {
            TRANSACTION_FEE_PLANS = feePlans.map((plan: FeePlans) => {
                return { name: `${plan.order_processing_charge_percentage}% + ${currencySymbol}${(plan.order_processing_charge / 100).toFixed(2)}`, value: plan.id }
            })
        }
        return TRANSACTION_FEE_PLANS;
    }
    
    const isIntegration = IntegrationsList.includes(host.toUpperCase() as OnboardingSources);
    let formRows:IDynamicFormRow[] = [
        {
            label: hTitles.payment,
            keyName: "",
            Component: FormTitle
        },
        {
            label: isIntegration ? "signup.form.yoelloEmployeeName" : "signup.form.paymentSpecialistName",
            keyName: "specialist_name",
            gridColumnOptions: { formCol: 6 },
            Component: FormTextBox,
            registerOptions: {
            },
        },
        {
            label:isIntegration ? "signup.form.yoelloEmployeeEmail" :  "signup.form.paymentSpecialistEmail",
            keyName: "specialist_email",
            gridColumnOptions: { formCol: 6 },
            Component: FormTextBox,
            registerOptions: {
                validate: (value: string) => validateEmail(value, true)
            },
            inputProperties: {

            },
            className: className.emailPosition
        },
        {
            label: hTitles.merchant,
            keyName: "",
            Component: FormTitle
        },
        {
            label: "forms.register.firstname",
            keyName: "first_name",
            gridColumnOptions: { formCol: 6 },
            Component: FormTextBox,
            registerOptions: {
                required: true,
                pattern: /(.|\s)*\S(.|\s)*/
            },
        },
        {
            label: "forms.register.lastname",
            keyName: "last_name",
            gridColumnOptions: { formCol: 6 },
            Component: FormTextBox,
            registerOptions: {
                required: true,
                pattern: /(.|\s)*\S(.|\s)*/
            },
        },
        {
            label: "forms.register.email",
            keyName: "contact_email",
            gridColumnOptions: { formCol: 6 },
            Component: FormTextBox,
            inputProperties: {
                type: 'email',
                autoComplete: 'email'
            },
            registerOptions: {
                required: true,
                validate: {
                    validateEmail,
                    //@ts-ignore
                    validateAccount
                }
            },
        },
        {
            label: "signup.form.contactNo",
            keyName: "contact_phone",
            gridColumnOptions: { formCol: 6 },
            Component: FormPhoneNumberBox,
            registerOptions: {
                required: true,
                minLength: 5
            },
            formProps: {
                triggerValidationOnChange: true,
                country: generatePhoneCountryCode(),
                priority: isBNALead ? {ca: 0, us: 1} : null,
                disableCountryGuess: isBNALead,
            }
        }, {
            label: "forms.details.venueName",
            keyName: "venue_name",
            gridColumnOptions: { formCol: 6 },
            Component: FormTextBox,
            className: className.venueNameRoot,
            formProps: {
                overrideJSXLabel: <div className={className.IconLabel}>
                    <InputLabel htmlFor={"venue_name"}>
                        {t('forms.details.venueName')}
                        <InfoIcon title={helperText[host].venue} />
                    </InputLabel>
                </div>
            },
            registerOptions: {
                required: true,
                pattern: /(.|\s)*\S(.|\s)*/
            },
            inputProperties: {
                helperText: t('signup.form.venueNameHelpText')
            },
        },
        {
            label: "signup.form.venueLocation",
            keyName: "venue_location",
            formProps: {
                selectOptions: getCountries()
            },

            Component: FormAutoComplete,
            gridColumnOptions: { formCol: 6 },
            registerOptions: {
                required: true,
            },
            className: className.venueLocationPosition,
            disabled: true,

        },
        {
            label: hasProcessingFee ? "signup.form.transactionFeePlan" : "signup.form.totalVenues",
            keyName: hasProcessingFee ? "processing_fee_plan_id" : "number_of_venues",
            formProps: {
                selectOptions: getSelectOptions(leadSource),
            },
            inputProperties: { placeholder: 'No items selected' },
            Component: hasProcessingFee ? FormAutoComplete : FormSelect,
            gridColumnOptions: { formCol: 6 },
            registerOptions: {
                required: true,
            },
            disabled: isBNALead || isZonalLead,
        },
        {
            label: "",
            keyName: "",
            formProps: {

            },
            inputProperties: { placeholder: 'No items selected' },
            Component: () => <div style={{ width: "100%" }}></div>,
            gridColumnOptions: { formCol: 6 },
            registerOptions: {
                required: true,
            },
        },
        {
            label: "",
            keyName: "",
            formProps: {

            },
            inputProperties: {},
            Component: () => <div className={className.TermsOfService}>
                <TermsOfService text={"tac"} />
            </div>,
            registerOptions: {
                required: true,
            },
        },
    ]
    if(host.toUpperCase() !== "PARTNERS"){
        formRows.splice(formRows.length - 2,0 ,...getIntegrationExtraInputs(host.toUpperCase()))
    }
    return formRows;
}

export function acquirerForm(t: any): IDynamicFormRow[] {
    const host = hostClient.host;
    function acquirerOptions() {
        switch (host) {
            case "cardsaver":
                return [{
                    name: 'Elavon',
                    value: Acquirers.elavon
                }, {
                    name: 'FiServ',
                    value: Acquirers.FiServ
                },
                {
                    name: 'AIB Merchant Services',
                    value: Acquirers.AIBMerchantServices
                }
                ]
            default:
                return [{
                    name: 'Elavon',
                    value: Acquirers.elavon
                }, {
                    name: 'Global Payments',
                    value: Acquirers.globalPayments
                }]
        }
    }

    return [
        {
            label: "signup.form.acquirer",
            keyName: "acquirer_name",
            formProps: {
                selectOptions: acquirerOptions()
            },
            Component: FormSelect,
            registerOptions: {
                required: true,
            },
        },
        {
            label: "signup.form.mcc",
            keyName: "mcc",
            Component: FormTextBox,
            registerOptions: {
                required: true
            },
        },
        {
            label: "signup.form.mid",
            keyName: "mid",
            Component: FormTextBox,
            registerOptions: {
                required: true
            },
            inputProperties: {
                helperText: t("signup.form.midHelper")
            }
        },
    ]
}